import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";
export const getOurPoliciesNextPageDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  nextPageOurPolicies: [
    {
      fieldName: "Next Page Name (EN)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english.data.nextPage.name",
      formType: "input",
      label: "Next Page Name (EN)",
      placeholder: "Enter content for Next Page Name (EN)",
      validation: { required: "Content for Next Page Name (EN) is required" },
    },
    {
      fieldName: "Next Page Name (MS)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_malay",
      className: "col-span-6",
      type: "content",
      name: "field_content_malay.data.nextPage.name",
      formType: "input",
      label: "Next Page Name (MS)",
      placeholder: "Enter content for Next Page Name (MS)",
      // validation: { required: "Content for Next Page Name (MS) is required" },
    },
    // {
      //   fieldName: "Next Page Link (MS)",
      //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_malay",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_malay.data.nextPage.link",
    //   formType: "input",
    //   label: "Next Page Link (MS)",
    //   placeholder: "Enter content for Next Page Link (MS)",
    //   // validation: { required: "Content for Next Page Link (MS) is required" },
    // },
    {
      fieldName: "Next Page Name (ZH)",
      fieldValue: "data.nextPage.name",
      parseField: "field_content_mandarin",
      className: "col-span-6",
      type: "content",
      name: "field_content_mandarin.data.nextPage.name",
      formType: "input",
      label: "Next Page Name (ZH)",
      placeholder: "Enter content for Next Page Name (ZH)",
      // validation: { required: "Content for Next Page Name (ZH) is required" },
    },
    {
      fieldName: "Next Page Link",
      fieldValue: "data.nextPage.link",
      parseField: "field_content_english",
      className: "col-span-6",
      type: "content",
      name: "field_content_english.data.nextPage.link",
      formType: "input",
      label: "Next Page Link",
      placeholder: "Enter content for Next Page Link",
      validation: { required: "Content for Next Page Link is required", validate: (value: string) => {
  const trimmed = value.trim();
  if (!trimmed.startsWith("/")) return "Please use an in-app page link, such as /example";
  if (["http://", "https://", "www."].some(p => trimmed.includes(p))) {
    return "Looks like an external link. Please use an in-app page link, such as /example";
  }
  return true;
} },
    },
    // {
    //   fieldName: "Next Page Link (ZH)",
    //   fieldValue: "data.nextPage.link",
    //   parseField: "field_content_mandarin",
    //   className: "col-span-6",
    //   type: "content",
    //   name: "field_content_mandarin.data.nextPage.link",
    //   formType: "input",
    //   label: "Next Page Link (ZH)",
    //   placeholder: "Enter content for Next Page Link (ZH)",
    //   // validation: { required: "Content for Next Page Link (ZH) is required" },
    // },
  ],
}